if (!customElements.get('collection-filter-nav')) {
  customElements.define(
    'collection-filter-nav',
    class CollectionFilterNav extends HTMLElement {
      connectedCallback() {
        this.swiper = null;

        this.swiperEl = this.querySelector('.collection-filter-nav__swiper');
        this.listEl = this.querySelector('.collection-filter-nav__list');

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.handleBreakpoint = this.handleBreakpoint.bind(this);
        this.handleReducedMotion = this.handleReducedMotion.bind(this);
        this.handleResize = this.debounce(this.onResize.bind(this), 150);

        this.mobileQuery.addEventListener('change', this.handleBreakpoint);
        this.reducedMotionQuery.addEventListener('change', this.handleReducedMotion);
        window.addEventListener('resize', this.handleResize);

        this.handleBreakpoint();
      }

      disconnectedCallback() {
        this.mobileQuery.removeEventListener('change', this.handleBreakpoint);
        this.reducedMotionQuery.removeEventListener('change', this.handleReducedMotion);
        window.removeEventListener('resize', this.handleResize);

        this.destroySwiper();
      }

      handleBreakpoint() {
        if (this.mobileQuery.matches) {
          this.syncMobileLayout();
        } else {
          this.destroySwiper();
          this.classList.remove('is-swiper', 'is-static');
        }
      }

      handleReducedMotion() {
        if (!this.swiper) return;

        this.destroySwiper();
        this.initSwiper();
      }

      onResize() {
        if (!this.mobileQuery.matches) return;

        this.syncMobileLayout();
      }

      applySlideSizing() {
        if (!this.listEl) return;

        const slides = this.listEl.querySelectorAll('.collection-filter-nav__slide');

        slides.forEach((slide) => {
          slide.style.width = 'auto';
          slide.style.flex = '0 0 auto';
        });
      }

      needsSwiper() {
        if (!this.swiperEl || !this.listEl) return false;

        return this.listEl.scrollWidth > this.swiperEl.clientWidth + 1;
      }

      syncMobileLayout() {
        if (!this.swiperEl || !this.listEl) return;

        this.destroySwiper();

        this.applySlideSizing();

        this.classList.remove('is-swiper');
        this.classList.add('is-static');

        requestAnimationFrame(() => {
          if (!this.mobileQuery.matches) return;
          if (!this.needsSwiper()) return;

          this.classList.remove('is-static');
          this.classList.add('is-swiper');

          this.initSwiper();
        });
      }

      initSwiper() {
        if (this.swiper) return;
        if (typeof Swiper === 'undefined') return;
        if (!this.swiperEl) return;

        const useMomentum = !this.reducedMotionQuery.matches;

        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 20,
          watchOverflow: true,

          freeMode: {
            enabled: true,
            momentum: useMomentum,
          },

          grabCursor: true,

          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },

          on: {
            resize: () => {
              this.updateSwiper();
            },
          },
        });

        requestAnimationFrame(() => {
          this.updateSwiper();

          requestAnimationFrame(() => {
            this.scrollToActive();
          });
        });
      }

      updateSwiper() {
        if (!this.swiper) return;

        this.applySlideSizing();
        this.swiper.update();
      }

      scrollToActive() {
        if (!this.swiper || !this.listEl) return;

        const activeSlide = this.listEl
          .querySelector('.collection-filter-nav__link--active')
          ?.closest('.collection-filter-nav__slide');

        if (!activeSlide) return;

        this.swiper.setTranslate(-activeSlide.offsetLeft);
      }

      destroySwiper() {
        if (!this.swiper) return;

        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      debounce(fn, delay) {
        let timer;

        return (...args) => {
          clearTimeout(timer);

          timer = setTimeout(() => {
            fn.apply(this, args);
          }, delay);
        };
      }
    }
  );
}